import React, { Component } from "react";
import { Row, Col } from 'react-bootstrap';

import CardPaymentForm from "./CardPaymentForm";
import { Auth, Http } from '../../../../support';
import Loading from "../../../../facturotopia/loading/Loading";
import ResponseError from "../../../../shared/responses/ResponseError";

class BuyPackage extends Component {
  constructor(props) {
    super(props);

    const { user, cliente } = Auth.getData();

    this.state = {
        billing: {
          id: cliente.id,
          rfc: cliente.rfc,
          razon_social: cliente.razon_social,
          contacto: cliente.contacto,
          nombre: user.nombre,
          uso_cfdi: cliente.uso_cfdi,
          email: user.email,
      },
    }
  }

  componentDidMount = async () => {
    this.setState({
      busy: true,
    });

    const { pk } = this.props.match.params || {};

    try {
      const response = await Http.get(`api/paquetes/${pk}`);

      this.setState({
        busy: false,
        ...this.data,
        data: response.data,
      });
    } catch (error) {
      this.setState({
        busy: false,
        error: error.data || error,
      });
    }
  };

  componentWillUnmount() {
    this.setState = () => {}
  }

  handleOnCreditCardChange = (event) => {
    this.setState({
      ...this.state,
      isValidCreditCard: event.isValid,
      payment: event.payment,
    })
  }

  renderError = () => {
    const { error } = this.props.cliente;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { error, data = {}, billing = {}, busy } = this.state;

    if (busy) {
      return <Loading />
    }

    return (
      <>
        { !!error && this.renderError() }

        <Row className="mb-3">
          <Col xs={ 12 } sm={ 12 } md={ 6 } lg={ 6 }>
            <CardPaymentForm
              data ={ data }
              billing={ billing }
            />
          </Col>
        </Row>
      </>
    )
  };
};

export default BuyPackage;
